import { SupportedPlatforms } from '@smg-real-estate/domus';

const isServer = (): boolean => import.meta.env.SSR;

const isPlatformIs24 = (): boolean => import.meta.env.VUE_APP_PLATFORM === 'is24';
const isPlatformHg = (): boolean => import.meta.env.VUE_APP_PLATFORM === 'hg';
const getCurrentPlatform = (): SupportedPlatforms =>
  isPlatformIs24() ? SupportedPlatforms.is24 : SupportedPlatforms.hg;

const getPlatformDomain = (): string =>
  isPlatformHg() ? 'https://www.homegate.ch' : 'https://www.immoscout24.ch';

const getTestPlatformDomain = (): string =>
  isPlatformHg() ? 'https://test.homegate.ch' : 'https://test.immoscout24.ch';

export {
  getCurrentPlatform,
  getPlatformDomain,
  getTestPlatformDomain,
  isPlatformHg,
  isPlatformIs24,
  isServer,
};
